export const surveyingCategoryIds = [1827, 1813, 1817, 1839, 1811, 1809, 1812];
